<template>
  <div>
    <Header></Header>
    <div class="wrapper">
      <div class="main row justify-content-between">
        <div class="col-md-10 col-11">
          <p class="title text-left">公 司 公 告</p>
          <p class="desc text-left">2013-3-8　<span class="author">及时雨小额贷款</span></p>
          <div class="main-content text-left">
            <p class="bold"><span>尊敬的客户 ：</span></p>
            <p class="normal">您好，近期发现有个别不法分子通过网络媒体以及其它非法手段，截取我司电话号码以上海嘉定及时雨小额贷款股份有限公司名义发布贷款信息及办理非法贷款。严重影响了我司声誉及侵害了广大客户的合法权益。为避免上当受骗，请勿轻信不法分子的承诺支付任何费用。如对贷款事宜有任何疑问，请及时致电我司客服热线:4008-212-999进行咨询。</p>
            <p class="normal">上海嘉定及时雨小额贷款股份有限公司特此声明：</p>
            <p class="normal">1、我司官方网站为：www.jishiyuloan.com其余均为假冒的官方网站。</p>
            <p class="normal">2、我司所有贷款业务，现只对上海地区开放，其他地区暂未开放。</p>
            <p class="normal">3、贷款合同的唯一签署方式为，客户本人在我司总部，静安区旺旺大厦17层现场签署，不通过其他形式签署合同。</p>
            <p class="normal">4、在与我司签署合同之前，任何人绝不会以任何方式向客户索取利息及其它费用。</p>
            <p class="normal">5、我司仅通过对公账户以银行转账方式放款，禁止以任何理由使用个人账户放款。</p>
            <p class="normal">6、对于冒用我司名义进行欺诈及办理非法贷款，造成客户经济损失的恶劣行为，一经发现将立即向公安机关报案，并坚决追究相关的法律责任。</p>
            <p class="normal">7、我司的商标、商号、域名及网站均为专有的重要资产，对未经授权而擅自抄袭、拷贝全部或部分者，我司保留采取法律措施的权利。</p>
            <p class="normal">8、客户如发现冒用上海嘉定及时雨小额贷款股份有限公司名义进行欺诈的行为，请及时致电我司客服热线 4008-212-999。</p>
            <p class="normal">我司重申: 上海嘉定及时雨小额贷款股份有限公司严格遵守国家规定和法令，致力为客户提供安心、安全的无抵押无担保的小额贷款服务。在合同签署之前，绝不收取任何费用。我司坚持抵制各种欺诈和冒名行为，并切实维护客户的合法权益。针对此类欺诈和冒名行为，我司将继续加强监控力度，并将就日后发现的任何新的欺诈手段及相关信息持续在我司网站上发布和更新，敬请留意。</p>
            <p class="text-right normal">上海嘉定及时雨小额贷款股份有限公司</p>
            <p class="text-right normal">2013年3月8日</p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Header from './Header'
  import Footer from './Footer'

  export default {
    name: "notice",
    components:{Header,Footer},
  }
</script>

<style scoped lang="less">
  p{margin:0;}
  a:hover{text-decoration: none;}

  //pc、laptop
  @media screen and (min-width: 769px) {
    .main{
      width:1300px !important;
    }
    .desc {
      font-size: 14px;
    }
    .bold {
      font-size: 22px;
    }
  }

  //phone
  @media screen and (max-width: 768px) {
    .wrapper{
      padding-top:90px;
    }
    .asideList{
      display: none;
    }
    .desc {
      font-size: 26px;
    }
    .normal{
      font-size: 30px;
    }
    .bold {
      font-size: 32px;
    }
  }

  .main {
    margin: 0 auto;
    padding:50px 0 190px 50px;

    //左边
    .title {
      font-size: 36px;
      font-weight: bold;
    }

    .desc {
      margin-bottom: 50px;
      line-height: 42px;

      .author {
        color: #006D73;
      }
    }

    .main-content {
      .normal, .bold {
        margin-bottom: 30px;
      }

      .bold {
        font-weight: bold;
        /*height:16px;*/
        span {
          /*background:linear-gradient(to bottom, transparent 0%, rgba(0,109,115,0.2) 50%, rgba(0,109,115,0.2) 100%);*/
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/notice.vue